
const he = {
    microspec: "מייקרוספיק",
    goBackToHome: "חזור לעמוד הבית",
    signIn: "כניסה לחשבון",
    optional: "בחירה",
    userSettings: "הגדרות משתמש",
    users: "משתמשים",
    manageUsers: "ניהול משתמשים",
    logout: "יציאה",
    account: "החשבון",
    security: "אבטחה",
    firstName: "שם פרטי",
    lastName: "שם משפחה",
    emailAddress: "דוא״ל",
    password: "סיסמה",
    phone: "מספר טלפון",
    address: "כתובת",
    save: "שמירה",
    saving: "שומר...",
    dangerZone: "אזור מסוכן",
    dangerZoneDeleteAccountText: "לחץ על הכפתור למטה למחיקת החשבון",
    // Login method selection
    selectLoginMethod: "בחר שיטת התחברות",
    selectRegistrationMethod: "בחר שיטת הרשמה",
    chooseLoginMethod: "בחר שיטת התחברות",
    email: "אימייל",
    phoneNumber: "מספר טלפון",
    loginError: "שגיאת התחברות, אנא נסה שוב",
    languages: "השפות",
    notifications: "ההתראות",
    noNewNotifications: "אין התראות חדשות",
    getResetLinkAfterButtonClick: "לחץ על הכפתור למטה כדי לקבל קישור לשחזור סיסמה להדוא״ל שמקושר לחשבונך",
    getResetLink: "קבל קישור לשחזור סיסמה",
    passwordReset: "שחזור סיסמה",
    simpleElementText: "בוא נתחיל לבנות משהוא חדש ומקסים בשימוש התשתית של מייקרוספיק",
    pleaseWait: "המתן בבקשה",
    deleteAccount: "מחיקת חשבון",
    cancel: "ביטול",
    confirm: "אישור",
    emailOrPasswordInvalid: "הדוא״ל או הסיסמה שגויים.",
    rememberMe: "תזכור אותי",
    forgotPassword: "שכחת סיסמה?",
    newAccount: "חשבון חדש?",
    signUp: "תרשום אותי",
    joinUsToday: "הצטרף אלינו היום",
    signUpError: "אירעה שגיאה, ייתכן שהדוא״ל כבר רשום או שהסיסמה אינה עומדת בדרישות האבטחה, אנא נסה שוב.",
    signUpInProgress: "יוצרים לך חשבון...",
    resetLinkSuccessfullySent: "קישור לשחזור סיסמה נשלח בהצלחה למייל שלך.",
    errorTryLater: "אירעה שגיאה, בבקשה תנסה מאוחר יותר",
    new: "חדש",
    newUnreadNotifications: "יש לך {0} התראות שלא נקראו",
    deleteAccountConfirmationDialogText: "נא לאשר מחיקת החשבון",
    notificationsWaitMessage: "המתן בבקשה עד סיום הפעולה",
    viewAll: "הצג הכל",
    invalidPhone: "מספר טלפון לא חוקי",
    invalidAddress: "כתובת לא חוקית",
    aboutYourself: "כתוב על עצמך",
    welcomeBack: "ברוך שובך",
    loggingInProgress: "הכניסה מתבצעת...",
    formProgress: "תהליך מילוי הטופס",
    additionalInformation: "מידע נוסף",
    // New authentication translations
    signingIn: "מתחבר...",
    verificationCode: "קוד אימות",
    otpSentMessage: "קוד אימות נשלח לטלפון שלך",
    verifyAndSignIn: "אמת והתחבר",
    verifying: "מאמת...",
    resendOtp: "שלח קוד מחדש",
    sendingOtp: "שולח...",
    resendOtpIn: "שלח קוד מחדש בעוד {seconds} שניות",
    // Profile completion
    completeYourProfile: "השלם את הפרופיל שלך",
    profileCompletionDescription: "אנא הכנס את שמך הפרטי ומשפחה להשלמת הרשמה",
    firstNameRequired: "שם פרטי נדרש",
    lastNameRequired: "שם משפחה נדרש",
    completeProfile: "השלם פרופיל",
    creatingProfile: "יוצר פרופיל...",
    registrationEmail: "אימייל:",
    registrationPhone: "טלפון:",
    back: "חזור",
    backToEmailSelection: "חזור לבחירת אימייל",
    backToPhoneSelection: "חזור לבחירת טלפון",
    userNotFound: "המשתמש לא נמצא. אנא בדוק את הפרטים.",
    errorCheckingUser: "שגיאה בבדיקת המשתמש. אנא נסה שוב.",
    invalidCredentials: "אימייל או סיסמה שגויים",
    enterYourPassword: "הכנס את הסיסמה שלך",
    enterVerificationCode: "הכנס את קוד האימות שנשלח",
    // Email verification translations
    verifyEmail: "אמת את האימייל שלך",
    verificationEmailSent: "שלחנו אימייל אימות אל",
    checkEmailInstructions: "אנא בדוק את האימייל שלך ולחץ על קישור האימות כדי להמשיך.",
    resendVerification: "שלח שוב אימייל אימות",
    verificationEmailResent: "אימייל האימות נשלח שוב בהצלחה!",
    verificationEmailError: "נכשל בשליחה חוזרת של אימייל האימות. אנא נסה שוב.",
    checkVerificationStatus: "אימתתי את האימייל שלי",
    checkingVerificationStatus: "בודק סטטוס אימות...",
    checking: "בודק...",
    sending: "שולח...",
    sentSuccessfully: "נשלח בהצלחה",
    emailVerified: "האימייל אומת!",
    emailVerifiedMessage: "האימייל שלך אומת בהצלחה. מעביר...",
    didntReceiveEmail: "לא קיבלת את האימייל?",
    checkSpamFolder: "בדוק בתיקיית הספאם או לחץ על שליחה חוזרת למעלה.",
    backToLogin: "← חזור להתחברות",
    tryDifferentEmail: "נסה אימייל אחר ←",
    // 404 Page translations
    notFoundTitle: "אופס! אבדנו בחלל הדיגיטלי",
    notFoundSubtitle: "הדף שאתה מחפש נסחף לחלל הדיגיטלי. אל תדאג, גם החוקרים הטובים ביותר לוקחים לפעמים פנייה שגויה!",
    notFoundBackToHome: "חזור לעמוד הבית",
    notFoundTryAgain: "נסה שוב",
    notFoundQuickNavigation: "ניווט מהיר",
    notFoundErrorCode: "שגיאה 404",
    notFoundPageLabel: "הדף לא נמצא",
    notFoundHome: "הבית",
    dragNDrop: "גרור ושחרר כמה קבצים כאן, או לחץ כדי לבחור קבצים",
    // Authentication error messages
    failedToSendOtp: "נכשל בשליחת קוד אימות. אנא נסה שוב.",
    failedToSendVerificationCode: "נכשל בשליחת קוד אימות. אנא נסה שוב.",
    failedToCreateProfile: "נכשל ביצירת פרופיל. אנא נסה שוב.",
    userAuthenticationMissing: "מידע אימות המשתמש חסר",
    noConfirmationResult: "לא נמצאה תוצאת אישור. אנא נסה שוב.",
    // Loader messages
    loadingInitialData: "טוען נתונים ראשוניים...",
    loadingApplicationData: "טוען נתוני יישום...",
    loadingUserProfile: "טוען פרופיל משתמש...",
    // Registration messages
    createNewAccount: "צור חשבון חדש",
    createNewPasswordDescription: "צור סיסמה חדשה לחשבון שלך",
    enterNewPassword: "הכנס סיסמה חדשה",
    confirmNewPassword: "אשר סיסמה חדשה",
    newAccountCreationNotice: "חשבון חדש יווצר עם כתובת המייל הזו",
    passwordRequirements: "הסיסמה חייבת להיות באורך של לפחות 8 תווים",
    creatingAccount: "יוצר חשבון...",
    createAccount: "צור חשבון",
    registrationError: "ההרשמה נכשלה. אנא נסה שוב.",
    passwordRequired: "סיסמה נדרשת",
    passwordTooShort: "הסיסמה חייבת להיות באורך של לפחות 8 תווים",
    passwordsDoNotMatch: "הסיסמאות אינן תואמות",
    emailAlreadyInUse: "כתובת המייל הזו כבר רשומה. אנא נסה להתחבר במקום זאת.",
    invalidEmail: "כתובת מייל לא חוקית",
    newAccountAutoCreationNoticeForEmail: "אם אין חשבון המשויך לכתובת מייל זו אנחנו נודיע לך על כך, כדי שתצור חשבון חדש, אתה תקבל הנחיות בתהליך ההרשמה",
    newAccountAutoCreationNoticeForPhone: "אם אין חשבון המשויך למספר טלפון זה אנחנו נודיע לך על כך, כדי שתצור חשבון חדש, אתה תקבל הנחיות בתהליך ההרשמה",
    // Account form translations
    updateYourAccountInfo: "עדכן את פרטי החשבון והעדפותיך",
    personalInformation: "מידע אישי",
    contactInformation: "פרטי יצירת קשר",
    fieldRequired: "שדה זה נדרש",
    pleaseFixErrors: "אנא תקן את השגיאות לפני השליחה",
    profileUpdatedSuccessfully: "הפרופיל עודכן בהצלחה!",
    verifiedField: "שדה זה מאומת ולא ניתן לשינוי",
    // Profile picture translations
    changeProfilePicture: "שנה תמונת פרופיל",
    selectProfilePicture: "בחר תמונת פרופיל",
    selectImageDescription: "בחר תמונה להעלאה כתמונת הפרופיל שלך. תוכל לחתוך ולהתאים אותה לפני השמירה.",
    clickToUpload: "לחץ להעלאה",
    selectImage: "בחר תמונה",
    cropYourImage: "חתוך את התמונה",
    uploadingProfilePicture: "מעלה תמונת פרופיל...",
    profilePictureUpdated: "תמונת הפרופיל עודכנה בהצלחה!",
    failedToUpdateProfilePicture: "נכשל בעדכון תמונת הפרופיל. אנא נסה שוב.",
    invalidFileType: "אנא בחר קובץ תמונה",
    fileTooLarge: "גודל הקובץ חייב להיות פחות מ-10MB",
    selectDifferent: "בחר אחר",
    saveProfilePicture: "שמור תמונת פרופיל",
    // Generic image upload translations
    uploadImage: "העלה תמונה",
    imageUploadedSuccessfully: "התמונה הועלתה בהצלחה!",
    failedToUploadImage: "נכשל בהעלאת התמונה. אנא נסה שוב.",
    uploadingImage: "מעלה תמונה...",
    saveImage: "שמור תמונה",
    changeProfilePictureDescription: "בחר תמונה להעלאה כתמונת הפרופיל שלך. תוכל לחתוך ולהתאים אותה לפני השמירה.",
    // Logo upload translations
    uploadLogo: "העלה לוגו",
    changeLogo: "שנה לוגו",
    uploadLogoDescription: "בחר תמונה להעלאה כלוגו. תוכל לחתוך ולהתאים אותה לפני השמירה.",
    logo: "לוגו",
    // User existence messages
    userAlreadyExists: "החשבון הזה כבר קיים. אנא התחבר במקום זאת.",
    userNotFoundPleaseRegister: "לא נמצא חשבון עם המידע הזה. אנא הירשם קודם.",
    dashboard: "לוח בקרה",
    systemAdminDashboard: "לוח בקרה למנהל מערכת",
    // Organization management translations
    organizationName: "שם המוסד",
    organizationDescription: "תיאור המוסד",
    organizations: "מוסדות",
    manageOrganization: "ניהול מוסדות",
    addOrganization: "הוסף מוסד",
    editOrganization: "ערוך מוסד",
    loadingOrganization: "טוען מוסד...",
    noOrganizationFound: "לא נמצאו מוסדות.",
    loadMore: "טען עוד",
    createFirstOrganization: "צור את המוסד הראשון שלך",
    createOrganization: "צור מוסד",
    // Branch management translations
    branches: "סניפים",
    manageBranches: "ניהול סניפים",
    addBranch: "הוסף סניף",
    loadingBranches: "טוען סניפים...",
    editBranch: "ערוך סניף",
    branchName: "שם הסניף",
    branchNameRequired: "שם הסניף *",
    branchNameIsRequired: "שם הסניף נדרש",
    branchNotFound: "הסניף לא נמצא",
    failedToLoadBranch: "טעינת נתוני הסניף נכשלה",
    failedToSaveBranch: "שמירת הסניף נכשלה",
    branchUpdatedSuccessfully: "הסניף עודכן בהצלחה!",
    branchCreatedSuccessfully: "הסניף נוצר בהצלחה!",
    updateBranchInfo: "עדכן מידע והגדרות סניף",
    fillBranchDetails: "מלא את הפרטים ליצירת סניף חדש",
    updateBranch: "עדכן סניף",
    createBranch: "צור סניף",
    location: "מיקום",
    city: "עיר",
    state: "מדינה/מחוז",
    zipCode: "מיקוד",
    country: "מדינה",
    // UpsertOrganization component
    organizationNotFound: "המוסד לא נמצא",
    failedToLoadOrganization: "נכשל בטעינת נתוני המוסד",
    basicInformation: "מידע בסיסי",
    organizationNameRequired: "שם המוסד *",
    industry: "תחום",
    selectIndustry: "בחר תחום",
    description: "תיאור",
    organizationDescriptionPlaceholder: "הכנס תיאור קצר של המוסד שלך...",
    emailAddressRequired: "כתובת אימייל *",
    branding: "מיתוג",
    remove: "הסר",
    primaryColor: "צבע ראשי",
    secondaryColor: "צבע משני",
    settings: "הגדרות",
    primaryCurrency: "מטבע ראשי",
    supportedCurrencies: "מטבעות נתמכים",
    localization: "לוקליזציה",
    language: "שפה",
    preferredLanguage: "שפה מועדפת",
    supportedLanguages: "שפות נתמכות",
    updateOrganizationInfo: "עדכן מידע המוסד והגדרות",
    fillOrganizationDetails: "מלא את הפרטים ליצירת מוסד חדש",
    organizationUpdatedSuccessfully: "המוסד עודכן בהצלחה!",
    organizationCreatedSuccessfully: "המוסד נוצר בהצלחה!",
    organizationNameIsRequired: "שם המוסד נדרש",
    contactEmailIsRequired: "אימייל יצירת קשר נדרש",
    pleaseEnterValidEmail: "אנא הכנס כתובת אימייל תקינה",
    pleaseEnterValidPhone: "אנא הכנס מספר טלפון תקין",
    pleaseEnterValidHexColor: "אנא הכנס צבע hex תקין",
    pleaseSelectImageFile: "אנא בחר קובץ תמונה",
    imageSizeLessThan5MB: "גודל התמונה צריך להיות פחות מ-5MB",
    pleaseFixFormErrors: "אנא תקן את שגיאות הטופס לפני השליחה",
    userNotAuthenticated: "המשתמש לא מאומת",
    systemError: "שגיאת מערכת. אנא נסה שוב מאוחר יותר.",
    organizationInfoMissing: "מידע על הארגון חסר.",
    organizationOwnershipInfoMissing: "מידע על בעלות הארגון אינו מוגדר.",
    unauthorized: "אין לך הרשאה לגשת לעמוד זה.",
    verificationError: "אירעה שגיאה במהלך אימות הגישה שלך. אנא נסה שוב.",
    accessDenied: "גישה נדחתה",
    failedToSaveOrganization: "נכשל בשמירת המוסד",
    updating: "מעדכן...",
    updateOrganization: "עדכן מוסד",
    creating: "יוצר...",
    restaurant: "מסעדה",
    technology: "טכנולוגיה",
    healthcare: "בריאות",
    finance: "פיננסים",
    education: "חינוך",
    retail: "קמעונאות",
    manufacturing: "ייצור",
    construction: "בנייה",
    foodAndBeverage: "מזון ומשקאות",
    transportation: "תחבורה",
    realEstate: "נדל״ן",
    marketing: "שיווק",
    consulting: "ייעוץ",
    other: "אחר",
    arabicSaudi: "ערבית (סעודיה)",
    hebrewIsrael: "עברית (ישראל)",
    englishUS: "אנגלית (ארה״ב)",
    pageNotFound: "דף לא נמצא",
    pageNotFoundText: "הדף שאתה מחפש לא קיים.",
    yearsOfExperience: "שנות ניסיון",
    invalidOtp: "קוד אימות לא תקין",
    otpVerificationFailed: "אימות הקוד נכשל",
    failedToResendOtp: "נכשל בשליחה חוזרת של קוד האימות",
    emailRegistrationNotAvailable: "הרשמה באימייל לא זמינה",
    otpSentSuccessfully: "קוד האימות נשלח בהצלחה",
    id: "מזהה",
    internalId: "מזהה פנימי",
    createdAt: "נוצר בתאריך",
    updatedAt: "עודכן בתאריך",
    unnamedOrganization: "מוסד ללא שם",
    noDescriptionProvided: "לא סופק תיאור",
    loadingDashboard: "טוען לוח בקרה...",
    brandingStatistics: "סטטיסטיקות מיתוג",
    withLogos: "עם לוגואים",
    withBranding: "עם מיתוג",
    currencyStatistics: "סטטיסטיקות מטבע",
    totalCurrenciesSupported: "סה\"כ מטבעות נתמכים",
    activityOverview: "סקירת פעילות",
    organizationsLastMonth: "מוסדות שנוצרו בחודש שעבר",
    ofTotal: "מהסך הכל",
    currenciesBreakdown: "פירוט מטבעות",
    totalOrganization: "סה\"כ מוסדות",
    totalUsers: "סה\"כ משתמשים",
    of: "מ",
    rowsPerPage: "מספר שורות בכל עמוד",
    search: "חיפוש",
    noSearchResults: "לא נמצאו תוצאות חיפוש",
    items: "פריטים",
    noDataAvailable: "אין נתונים זמינים",
    actions: "פעולות",
    refresh: "רענן",
    export: "ייצא",
    columnSettings: "הגדרות עמודות",
    selected: "נבחר",
    moreThan: "יותר מ-",
    exportData: "ייצוא נתונים",
    exportFormat: "פורמט ייצוא",
    exportScope: "היקף ייצוא",
    currentPage: "עמוד נוכחי",
    pageRange: "טווח עמודים",
    allPages: "כל העמודים",
    fromPage: "מעמוד",
    toPage: "לעמוד",
    exportInfo: "מידע על ייצוא",
    // Organization Context
    workspaceContext: "הקשר עבודה",
    selectOrganization: "בחר מוסד",
    selectBranch: "בחר סניף",
    allBranches: "כל הסניפים",
    currentContext: "הקשר נוכחי",
    noOrganizationMembership: "אינך חבר בשום מוסד",
    noOrganizationMembershipDescription: "עליך להיות מוזמן למוסד כדי לגשת ללוח בקרה זה.",
    loadingOrganizationContext: "טוען הקשר עבודה...",
    retry: "נסה שוב",
    roles: "תפקידים",
    nextSteps: "צעדים הבאים",
    contactOrganizationAdmin: "צור קשר עם מנהל הארגון",
    contactOrganizationAdminDescription: "פנה למנהל הארגון שלך כדי לבקש גישה.",
    waitForInvitation: "המתן להזמנה",
    waitForInvitationDescription: "ברגע שתוזמן, תוכל לגשת ללוח המחוונים ולתכונותיו.",
    checkForMemberships: "בדוק עבור חברויות",
    organizationsManager: "מנהל מוסדות",
    // UpsertMemberToOrganization component
    assignMemberToOrganization: "הוסף חבר למוסד",
    findUser: "מצא משתמש",
    assignRoles: "הקצה תפקידים",
    organizationIdRequired: "מזהה מוסד נדרש",
    failedToValidateIds: "נכשל באימות מזהי מוסד/סניף",
    pleaseEnterSearchValue: "אנא הכנס כתובת אימייל או מספר טלפון",
    failedToSearchUser: "חיפוש משתמש נכשל",
    pleaseSelectUser: "אנא בחר משתמש",
    pleaseSelectAtLeastOneRole: "אנא בחר לפחות תפקיד אחד",
    failedToAssignMember: "הוספת חבר נכשלה",
    memberAlreadyInBranch: "החבר כבר קיים בסניף שנבחר",
    memberAssignedSuccessfully: "חבר הוקצה בהצלחה",
    userAddedToOrgAndBranch: "המשתמש נוסף למוסד ולסניף עם התפקידים שנבחרו.",
    userAddedToOrg: "המשתמש נוסף למוסד עם התפקידים שנבחרו.",
    addAnotherMember: "הוסף חבר נוסף",
    close: "סגור",
    findUserToAdd: "מצא משתמש להוספה",
    searchByEmail: "חפש לפי אימייל",
    searchByPhone: "חפש לפי טלפון",
    searchByEmailOrPhone: "חפש לפי אימייל או טלפון",
    searchResults: "תוצאות חיפוש",
    selectRolesForMember: "בחר את התפקידים שברצונך להקצות לחבר זה.",
    organizationRoles: "תפקידי מוסד",
    branchRoles: "תפקידי סניף",
    confirmAssignment: "אשר הקצאה",
    user: "משתמש",
    memberWillReceiveNotification: "החבר יקבל התראה על תפקידו החדש.",
    assignMember: "הקצה חבר",
    next: "הבא",
    validatingInformation: "מאמת מידע...",
    userAlreadyOrgMember: "משתמש זה כבר חבר פעיל במוסד זה",
    userAlreadyOrgMemberCanAddToBranch: "משתמש זה כבר חבר במוסד ויתווסף לסניף שנבחר",
    userAlreadyBranchMember: "משתמש זה כבר חבר פעיל בסניף זה",
    selectOrganizationAndBranch: "בחר מוסד וסניף",
    selectBranchOptional: "בחר סניף (אופציונלי)",
    pleaseSelectOrganization: "אנא בחר מוסד",
    failedToLoadOrganizations: "טעינת מוסדות נכשלה",
    userWillBeAssignedToBranch: "המשתמש יוקצה למוסד ולסניף שנבחרו",
    userWillBeAssignedToOrg: "המשתמש יוקצה למוסד שנבחר בלבד",
    selectedUser: "משתמש נבחר",
    userFound: "משתמש נמצא",
    identifier: "מזהה",
    authenticationMethod: "שיטת אימות",
    availableMethods: "שיטות זמינות",
    errorSearchingUser: "שגיאה בחיפוש משתמש. אנא נסה שוב.",
    // ManageMembers component
    branchMembers: "חברי הסניף",
    organizationMembers: "חברי מוסד",
    noBranchesFound: "לא נמצאו סניפים",
    unnamedBranch: "סניף ללא שם",
    memberAddedSuccessfully: "חבר נוסף בהצלחה",
    memberSuspended: "חבר הושעה בהצלחה",
    memberActivated: "חבר הופעל בהצלחה",
    memberRemoved: "חבר הוסר בהצלחה",
    failedToUpdateMember: "עדכון חבר נכשל",
    failedToRemoveMember: "הסרת חבר נכשלה",
    member: "חבר",
    manageMembers: "ניהול חברים",
    status: "סטטוס",
    noRoles: "אין תפקידים שהוקצו",
    active: "פעיל",
    suspended: "מושעה",
    invited: "מוזמן",
    transferred: "הועבר",
    joinedAt: "הצטרף ב",
    notYetJoined: "עדיין לא הצטרף",
    addedOn: "נוסף ב",
    addMember: "הוסף חבר",
    suspend: "השעה",
    activate: "הפעל",
    noMembers: "לא נמצאו חברים",
    suspendMember: "השעה חבר",
    activateMember: "הפעל חבר",
    suspendMemberConfirm: "האם אתה בטוח שברצונך להשעות חבר זה? הם יאבדו גישה למוסד/סניף.",
    activateMemberConfirm: "האם אתה בטוח שברצונך להפעיל חבר זה? הם יחזרו לקבל גישה למוסד/סניף.",
    removeMember: "הסר חבר",
    removeMemberWarning: "לא ניתן לבטל פעולה זו. החבר יוסר לצמיתות.",
    removeMemberConfirm: "האם אתה בטוח שברצונך להסיר חבר זה?",
    processing: "מעבד...",
    unknownUser: "משתמש לא ידוע",
    loading: "טוען...",
    ecommerceBusinessManager: "מנהל עסקי מסחר אלקטרוני",
    manageModules: "ניהול מודולים",
    modules: "מודולים",
    addModule: "הוסף מודול",
    enablableModules: "מודולים ניתנים להפעלה",
    manageSystemModules: "הפעל או השבת מודולי מערכת כדי להתאים אישית את חווית הפלטפורמה שלך",
    enabled: "מופעל",
    disabled: "מושבת",
    organizationContextAware: "מודע להקשר ארגוני",
    noEnablableModules: "אין מודולים ניתנים להפעלה",
    noModulesAvailable: "אין כרגע מודולים זמינים להפעלה או השבתה",
    enableModule: "הפעל מודול",
    disableModule: "השבת מודול",
    enableModuleConfirmation: "פעולה זו תפעיל את המודול למשך 14 יום. המודול יהיה נגיש לארגון שלך במהלך תקופה זו.",
    disableModuleConfirmation: "פעולה זו תשבית את המודול באופן מיידי. משתמשים לא יוכלו יותר לגשת לתכונות המודול הזה.",
    module: "מודול",
    activePeriod: "תקופה פעילה",
    startDate: "תאריך התחלה",
    endDate: "תאריך סיום",
    // Module access control translations
    moduleNotEnabled: "מודול לא מופעל",
    moduleNotEnabledDescription: "מודול זה אינו מופעל כרגע עבור הארגון שלך. אנא פנה למנהל המערכת כדי להפעיל גישה לתכונה זו.",
    requestedModule: "מודול מבוקש",
    currentOrganization: "ארגון נוכחי",
    moduleEnableInstructions: "כדי להפעיל מודול זה, בקר בדף ניהול המודולים בהגדרות מנהל הארגון והפעל אותו עבור הארגון שלך.",
    goToModules: "עבור למודולים",
    goBack: "חזור",
    // Organizational Layout translations
    loadingOrganizationData: "טוען נתוני ארגון...",
    illegalState: "בקשה לא חוקית",
    illegalStateDescription: "דף זה דורש מידע ארגוני תקף כדי להציג תוכן. אנא גש לדף זה דרך הניווט המתאים.",
    organizationNotFoundDescription: "הארגון שאתה מחפש לא קיים או הוסר. אנא בדוק את מזהה הארגון ונסה שוב.",
    branchNotFoundForOrganization: "סניף לא נמצא",
    branchNotFoundForOrganizationDescription: "הסניף המבוקש לא קיים בתוך ארגון זה. ייתכן שהוא הוסר או שמזהה הסניף שגוי.",
    unexpectedError: "משהו השתבש",
    unexpectedErrorDescription: "אירעה שגיאה בלתי צפויה בעת טעינת נתוני הארגון. אנא נסה שוב מאוחר יותר או פנה לתמיכה אם הבעיה נמשכת.",
    // Permissions Management translations
    permissionsManagement: "ניהול הרשאות",
    permissionsManagementDescription: "הצג וסנכרן הרשאות מערכת עם מסד הנתונים",
    manageAuthentication: "ניהול אימות",
    filterByModule: "סנן לפי מודול",
    filter: "סנן",
    allModules: "כל המודולים",
    synced: "מסונכרן",
    notSynced: "לא מסונכרן",
    syncAll: "סנכרן הכל",
    syncing: "מסנכרן...",
    syncToDatabase: "סנכרן למסד נתונים",
    permissionId: "מזהה הרשאה",
    displayName: "שם תצוגה",
    total: "סה״כ",
    // Permission names
    manageOrganizationsPermission: "ניהול ארגונים",
    manageOrganizationsPermissionDesc: "יצירה, עריכה ומחיקה של ארגונים",
    manageUsersPermission: "ניהול משתמשים",
    manageUsersPermissionDesc: "יצירה, עריכה וניהול חשבונות משתמשים",
    manageModulesPermission: "ניהול מודולים",
    manageModulesPermissionDesc: "הפעלה או השבתה של מודולי מערכת",
    managePermissionsPermission: "ניהול הרשאות",
    managePermissionsPermissionDesc: "הגדרה והקצאת הרשאות",
    manageProductsPermission: "ניהול מוצרים",
    manageProductsPermissionDesc: "יצירה, עריכה וניהול קטלוג מוצרים",
    manageOrdersPermission: "ניהול הזמנות",
    manageOrdersPermissionDesc: "צפייה ועיבוד הזמנות לקוחות",
    viewAnalyticsPermission: "צפייה בניתוחים",
    viewAnalyticsPermissionDesc: "גישה לניתוחים ודוחות עסקיים",
    manageCustomersPermission: "ניהול לקוחות",
    manageCustomersPermissionDesc: "צפייה וניהול מידע לקוחות",
    noPermissionsFound: "לא נמצאו הרשאות",
    all: "הכל",
    createdWithLove: "נוצר באהבה ❤️ על ידי מיקרוספק",
    copyrightsReserved: "כל הזכויות שמורות",
    learnMore: "למד עוד",
    faqTitle: "שאלות נפוצות",
    faqSubtitle: "מצא תשובות לשאלות נפוצות על השירותים שלנו",
    faqSearchPlaceholder: "חפש שאלה...",
    noFaqSearchResults: "לא נמצאו תוצאות לחיפוש בשאלות נפוצות",
    lightMode: "מצב בהיר",
    darkMode: "מצב כהה",
    contactUs: "צור קשר",
    submit: "שלח",
    clear: "נקה",
    formSuccessMessage: "הטופס נשלח בהצלחה!",
    fullName: "שם מלא",
    message: "הודעה",
    // Localized Input
    localizedInputManageLocalizations: "נהל תרגומים",
    localizedInputClickIconToLocalize: "לחץ על סמל השפה כדי לתרגם לכל השפות",
    localizedInputEditAllLanguages: "ערוך ערכים עבור כל השפות הנתמכות",
    localizedInputPreferred: "מועדף",
    localizedInputEnterValue: "הזן ערך",
}

const getHebrewMap = () => {
    return he
}

export default getHebrewMap